// Havyn — Collection Editorial Rows: mood filter behavior.
// Scoped per-section instance so multiple sections on a page don't collide.
document.querySelectorAll('.hv-editorial').forEach((root) => {
  const filterBar = root.querySelector('[data-hv-filter]');
  if (!filterBar) return;

  const chips = filterBar.querySelectorAll('.hv-e-chip');
  const rows = root.querySelectorAll('.hv-e-row');
  const count = filterBar.querySelector('[data-hv-count]');
  const empty = root.querySelector('[data-hv-empty]');

  function apply(mood) {
    let shown = 0;
    rows.forEach((row) => {
      const rowMood = row.getAttribute('data-moods') || '';
      const on = mood === 'Alle' || rowMood === mood;
      row.hidden = !on;
      if (on) shown += 1;
    });
    chips.forEach((chip) => {
      chip.setAttribute('aria-pressed', String(chip.getAttribute('data-mood') === mood));
    });
    if (count) {
      count.textContent = shown === rows.length ? '' : `${shown} von ${rows.length}`;
    }
    if (empty) empty.hidden = shown !== 0;
  }

  chips.forEach((chip) => {
    chip.addEventListener('click', () => apply(chip.getAttribute('data-mood')));
  });
});
